<template>
  <header :class="{active: menuIsShown}">
    <div class="decor"></div>
    <router-link :to="{name: 'home'}" title="Globulo Quest" class="logo"><img src="@/assets/images/globulo-quest.png" alt="Globulo Quest Logo" title="Globulo Quest"/></router-link>
    
    <div class="connexion">
      <p id="boxConnect" @click="showModal">Se connecter</p>
      <bouton href="signup">Créer mon compte Globulo</bouton>
    </div>
    
    <div class="bt-mobile" @click="showMenu"></div>
    <nav class="main-menu" >
      <ul>
        <li class="close-menu" @click="showMenu"><i class="fas fa-times"></i>Fermer le menu</li>
        <li class="home"><router-link :to="{ name: 'home' }" title="" class="button">Accueil</router-link></li> 
        <li><slimy-button href="concept">Le Concept Globulo Quest</slimy-button></li> 
      </ul>
    </nav>
    
    <transition name="modal">
      <modal-login class="modal-login" v-if="modalIsShown" @close="closeModal"></modal-login>
    </transition>
  </header>
</template>

<script>
  import Bouton from '@/components/Bouton.vue';
  import SlimyButton from '@/components/SlimyButton.vue';
  import ModalLogin from '@/components/modals/Login.vue';

  export default {
    props: ['connect'],
    components: { Bouton, SlimyButton, ModalLogin },
    data () {
      return {
       modalIsShown: false,
       modalBadgeIsShown: false,
       menuIsShown: false
      }
    },
    methods: {
      showModal () {
        this.modalIsShown = true;
      },
      closeModal () {
        this.modalIsShown = false;
      },
      showMenu () {
        this.menuIsShown = !this.menuIsShown;
      }
    },
    watch:{
      $route (to, from){
        this.menuIsShown = false;
      }
    }
  }
</script>

<style scoped>

  .user-infos {
    width: 20%;
    max-width: 270px;
    float: right;
    background: #413491;
    position: relative;
    top: -20px;
    right: -20px;
    height: 88px;
    padding: 15px 10px 15px 15px ;
    color: white;
    font-family: 'blogger_sansbold';
    border-bottom: 3px dashed white;
    box-shadow: inset 35px 0px 45px rgba(0,0,0,0.2);
  }
  .user-infos .user-avatar {
    width: 60px;
    height: 60px;
    background: white;
    border-radius: 100px;
    border: 2px solid #888;
    overflow: hidden;
    display: inline-block;
    float: right;
    padding: 10px; 
   }
  .user-infos p {
    display: inline-block;
    color: white;
    font-family: 'blogger_sansbold';
    text-align: right;
    float: right;
    line-height: 18px;
    margin: 0px;
    font-size: 14px;
    margin-right: 10px;
    top: 10px;
    position: relative;
  }
  .user-infos .user-notifs {
    display: inline-block;
    position: relative;
    float: left;
    font-size: 35px;
    color: white;
  }
  .user-infos .user-notifs:hover { opacity: 0,5; }
  .user-infos .user-notifs span {
    position: absolute;
    height: 25px;
    width: 25px;
    background: #de2128;
    border-radius: 30px;
    text-align: center;
    top: 15px;
    right: -15px;
    font-size: 14px;
    padding: 2px 0;
  }
  
</style>
